/** Pass a value to this function to have TypeScript make sure it can never happen. */
export const exhaustiveCheck = (value: never): never => {
  throw new Error(
    `Unhandled value (${JSON.stringify(value)}) in calling function.`
  );
};

// Credit:
// https://www.meticulous.ai/blog/safer-exhaustive-switch-statements-in-typescript
